import pouchdb from "./pouchdb";


export interface ResultDb<dataProps> {
    status: "ok" | "error" | "not_found",
    msg?: string,
    row?: dataProps 
    rows?: dataProps[]
}

interface Error {
    error: string,
    id: string,
    message: string;
    name: string;
    reason: string;
    status: number;
}
interface FieldsFilterParams {
    fieldName: string,
    fieldValue: any,
    mangoQuery: '$eq' | '$gt' | '$gte' | '$lt' | '$lte' | '$in' | '$regex' | '$elemMatch' | '$ne' | ''
}
export interface FilterParamsInterface {
    fieldsFilter: Array<FieldsFilterParams>;
    indexName: string;
    sortBy?: string[];
    limit?: number;
}

export interface FilterViewParams {
    viewName: string,
    resultViewFull: boolean,
    opt: PouchDB.Query.Options<{}, {}>
}

export interface PrmsSync {
    functionCallbackChange: (prms: PouchDB.Replication.SyncResult<{}>) => void;
    handleCallbackPause: (prmState: any) => void;
    handleErrorCallback: (error: any) => void;
    handleFirstReplicateDone: (info: any) => void;
    dataAmericana: string;
}

interface LoginDbProps {
    login: string
    pass: string
    db: string
}

const urlRemote = process.env.PARCEL_BASE_URL;

class Db<dataProps> {
    private dbRemote: PouchDB.Database;
    private sync: any;

    constructor() {
        this.dbRemote = {} as PouchDB.Database;

    }

    connected = async ():Promise<{status:"ok"|"error",msg:string}> => {
        try {
            const info = await this.dbRemote.info();
            console.log("info dbRemote", info);
            return info.db_name !== undefined ? {status:"ok",msg:"Conectado com sucesso!"} : {status:"error",msg:"Não conectado"}   ;
        }
        catch (error:any) {
            console.log("error connected", error);
            return {status:"error",msg:error.message} ;
        }
    }

    connect = async (props: LoginDbProps):Promise<{status:"ok"|"error",msg:string}> => {
        try {
            console.log("Connect",props)
            this.dbRemote = new pouchdb(urlRemote + props.db, { auth: { username: props.login, password: props.pass } });
            return this.connected()
        } catch (error) {
            console.log("error connect db", error);
            return {status:"error",msg:"Error connect db"+error}
        }
    }

    getDocID = async (doc_id: string): Promise<ResultDb<dataProps>> => {
        try {
            console.log("chamou getDocID", doc_id);
            const data = await this.dbRemote.get(doc_id, { conflicts: true, attachments: true, binary: true });
            return { status: 'ok', row: data as dataProps, msg: "Registro localizado com sucesso!" };
        } catch (error) {
            console.log("error getDocID", error)
            return { status: 'error', msg: 'Falha na busca do doc.' + JSON.stringify(error) };
        }
    }

    getAllDocsLocal = async (): Promise<ResultDb<dataProps>> => {
        try {
            let result = await this.dbRemote.allDocs({ include_docs: true, descending: true, });
            console.log("getAllDocsLocal result", result);
            let rows: dataProps[] = [];
            result.rows.map(row => {
                rows.push(row.doc as dataProps);
            })
            return { status: 'ok', rows: rows, msg: "Registros localizados com sucesso!" }
        } catch (error) {
            return { status: 'error', msg: 'Ocorreu uma falha ao buscar os dados locais.' + error }
        }
    }

    upsertData = (doc_id: string, data: any) => {
        data.upsert = data.upsert || 0;
        data.upsert++;
        return this.dbRemote.upsert(doc_id, (doc) => { doc = data; return doc }).then((resp) => {
            return { status: 'ok', row: resp, msg: "Registro com conflito, corrigido com sucesso!" };
        })
            .catch((err) => {
                return { status: 'error', msg: err, row: {} as any };
            })
    }

    createData = async (data: any) => {
        /* @createData
        * cria novo documento local
        */
        return this.dbRemote.post(data).then((response) => {
            return { status: 'ok', row: response, msg: "Registro criado com sucesso!" };
        }).catch((err) => {
            console.log("error createData", err)
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    updateData = async (data: any) => {
        return this.dbRemote.put(data).then((response) => {
            return { status: 'ok', row: response, msg: "Registro atualizado com sucesso!" }
        }).catch((err: any) => {
            console.log("error updateData", err)
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    deleteData = async (data: any) => {
        data._deleted = true;
        return this.dbRemote.put(data).then((response) => {
            return { status: 'ok', row: response, msg: "Regsitro removido com sucesso!" }
        }).catch((err) => {
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    salvar = async (row: any): Promise<ResultDb<dataProps>> => {
        console.log("chamou salvar", row);
        const detalharError = (error: any) => {
            let detalhes: Error = {
                error: error['error'],
                id: error['id'],
                message: error['message'],
                name: error['name'],
                reason: error['reason'],
                status: error['status'],
            }
            return detalhes;
        }
        if (row._rev) {
            //Update
            try {
                const result = await this.updateData(row);
                console.log("salva updade result", result)
                if (result.status === 'ok') {
                    row._rev = result.row.rev;
                    return { status: 'ok', row: row, msg: result.msg };
                } else {
                    let error = detalharError({ message: "Ocorreu um falha e os dados não foram salvos. Detalhes: " + JSON.stringify(result) })
                    return { status: 'error', msg: error.message }
                }
            } catch (erro) {
                let error = detalharError(erro)
                return { status: 'error', msg: error.message };
            }
        } else {
            //new
            try {

                const result = await this.createData(row);
                if (result.status === 'ok') {
                    row._id = result.row.id;
                    row._rev = result.row.rev;
                    return { status: 'ok', row: row, msg: result.msg };
                } else {
                    let error = detalharError({ message: "Ocorreu um falha e os dados não foram salvos. Detalhes: " + JSON.stringify(result) })
                    return { status: 'error', msg: error.message }
                }
            } catch (erro) {
                let error = detalharError(JSON.stringify(erro))
                return { status: 'error', msg: error.message };
            }
        }
    };

    salveAll = async (docs: any[]): Promise<ResultDb<dataProps>> => {
        try {
            const resp = await this.dbRemote.bulkDocs(docs);
            let rows: dataProps[] = [];
            resp.map(respRow => {
                let doc = docs.find(doc => doc._id === respRow.id);
                doc._rev = respRow.rev;
                rows.push(doc);
            });
            return { status: "ok", rows: rows as dataProps[] };
        } catch (error: any) {
            return { status: 'error', msg: error, rows: [] as dataProps[]  };
        }
    }

    public filter = async (prm: FilterParamsInterface): Promise<ResultDb<dataProps>> => {
        //montar estrutura index e selector
        try {
            console.log("prm filter", prm);
            var fields = Array<string>()
            var selector: any = {};
            var find: any = {};
            prm.fieldsFilter.map(value => {
                if (value) {
                    fields.push(value.fieldName);
                    if (value.mangoQuery !== '') {
                        selector = {
                            ...selector,
                            [value.fieldName]: {
                                [value.mangoQuery]: Array.isArray(value.fieldValue) ? value.fieldValue.valueOf() : value.fieldValue
                            }
                        }
                    } else {
                        selector = {
                            ...selector,
                            [value.fieldName]: Array.isArray(value.fieldValue) ? value.fieldValue.valueOf() : value.fieldValue
                        }

                    }
                }
            })
            find['selector'] = selector
            //find['index_name'] = prm.indexName nao funciona com o couchdb remoto
            find['limit'] = 1000

            let respCreateIndex = await this.dbRemote.createIndex({
                index: {
                    fields: fields,
                    //ddoc: prm.indexName nao funciona com o couchdb remoto
                    name: prm.indexName,//so com o couchdb
                }
            })

            if (respCreateIndex.result) {
                console.log("opt find com index", find)
                //console.log("start filter find"+new Date().toISOString())
                let respFind = await this.dbRemote.find(find);
                //console.log("end filter find"+new Date().toISOString())
                console.log("resp Find", respFind);
                return { status: 'ok', rows: respFind.docs as dataProps[] };
            } else {
                return { status: 'error', msg: 'Erro ao criar o index. Detalhes ' + respCreateIndex, rows: [] as dataProps[] };
            }

        } catch (error) {
            return { status: 'error', msg: 'Falha geral na estrutura da função filter em Db. Detalhes ' + error, rows: [] as dataProps[] };
        }
    }

    public filterView = async (prm: FilterViewParams): Promise<ResultDb<dataProps>> => {
        try {
            const { opt, resultViewFull, viewName } = prm
            console.log("opt em filterView", opt,viewName);
            let resp = await this.dbRemote.query(viewName, opt);
            console.log("resp filterView", resp);
            let rows: any[] = [];
            if (!resultViewFull) {
                resp.rows?.map(row => {
                    if (opt.include_docs)
                        rows.push(row.doc);
                    else
                        rows.push(row.value);
                });
            } else {
                rows = resp.rows! as dataProps[];
            }
            return { status: "ok", rows: rows as dataProps[] }
        } catch (error: any) {
            console.log("Error filterView", error);
            return { status: 'error', msg: 'Falha geral na estrutura da função filterView em Db. Detalhes ' + error };
        }

    }

    public replicar = async (dataRep: string): Promise<{ status: 'ok' | 'error', data?: any, mensagem?: any }> => {
        try {
            console.log("chamou replicar", dataRep)
            //verificar se ja fez alguma replicacao no dia atual
            let lastReplicatedAt = localStorage.getItem("last_replicated_at_" + this.dbRemote.name);
            let hoje = new Date().toISOString().substring(0, 10);
            if (lastReplicatedAt === hoje) {
                //esse e um procedimento para que a inicializacao do app seja mais rapida,
                console.log("ja replicou hoje, ignorando replicacao");
                return { status: "ok", mensagem: "Já foi replicado hoje." };
            }
            let resp = this.dbRemote.replicate.from(this.dbRemote, {})
                .on("complete", (info) => {
                    console.log("replicar complete", info)
                    localStorage.setItem("last_replicated_at_" + this.dbRemote.name, hoje);
                    return { status: "ok" }
                })
                .on("change", (info) => {
                    console.log("replicar change", info)
                })
                .on("denied", (info) => {
                    console.log("replicar denied", info)
                })
                .on("error", (err) => {
                    return { status: "error", mensagem: err }
                })
            const value = await resp;
            if (value.ok) {
                return { status: "ok" };
            } else {
                //se ouve algum erro, mas ja foi replicado algum dia, retornar ok
                if (lastReplicatedAt !== null) {
                    return { status: "ok", mensagem: "Já foi replicado anteriormente." };
                }   
                return { status: "error", mensagem: value.errors };
            }

        } catch (error) {
            console.log("error ao replicar", error)
            return { status: "error", mensagem: error }
        }
    }

    public startSync = (prms: PrmsSync) => {
        console.log("chamou startSync", prms)
        let dtSync = prms.dataAmericana;
        //let filterSync = "func/replicate_doc_app_scambPDV";
        this.sync = this.dbRemote.sync(this.dbRemote, {
            live: true,
            retry: true,
        })
            .on("change", (change) => { prms.functionCallbackChange(change); console.log("change sync", prms) })
            .on("paused", (msg) => { prms.handleCallbackPause(msg); console.log("pause loading data", msg) })
            .on("error", (msg) => { console.log("error", msg) })
            .on("complete", (msg) => { console.log("complete sync", msg) })
    }

    public disconnectDb = () => {
        try {
            this.dbRemote.close();
            //this.dbLocal.close();
            return { status: "ok", mensagem: "Desconectado com sucesso!" };
        } catch (error) {
            console.log("error disconnectDb", error);
            return { status: "error", mensagem: "Erro ao desconectar o banco de dados: " + error };
        }
    }    
}

export const db = new Db()
